// extracted by mini-css-extract-plugin
export default {"root":"FeaturesList__root--3QscK","item":"FeaturesList__item--3ByTN"};